import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 203px;
  padding-right: 51px;
`;

export const Button = styled.button<{ selected: boolean }>`
  border: 0;
  font-family: 'Inter-Medium';
  font-weight: bold;
  font-size: 15px;
  line-height: 125%;
  color: ${props => props.selected ? '#6E30E9' : '#4D4D4D'};
  background: #FFF;
  height: 44px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const ButtonLabel = styled.h2`
  border: 0;
  font-family: 'Inter-Medium';
  font-weight: bold;
  font-size: 15px;
  line-height: 125%;
  // @media (max-width: 1441px) {
  //   display: none;
  // }
`;